module.exports = __webpack_public_path__ + "src/assets/games/43/95.jpg";